<template>
  <AppBar color="blue-grey lighten-4">
    <template v-slot:left-side>
      <v-icon class="mr-5">mdi-book-open-page-variant</v-icon>
      <v-toolbar-title
        >Kurs: <strong>{{ activeExecutionCourseName }}</strong></v-toolbar-title
      >

      <CourseBreadcrumb />
    </template>
    <template v-slot:right-side>
      <AccountBar />
    </template>
  </AppBar>
</template>

<script>
import AppBar from '@/components/shared/AppBar.vue';
import AccountBar from '@/components/shared/AccountBar.vue';
import { createNamespacedHelpers } from 'vuex';
import CourseBreadcrumb from '@/components/breadcrumbs/CourseBreadcrumb.vue';

const { mapState, mapGetters } = createNamespacedHelpers('courseExecution');

export default {
  components: {
    AppBar,
    AccountBar,
    CourseBreadcrumb
  },
  computed: {
    ...mapState(['executingCourse']),
    ...mapGetters(['activeExecutionCourseName'])
  }
};
</script>
